import { render, staticRenderFns } from "./Edelstahl.vue?vue&type=template&id=f4557292&"
import script from "./Edelstahl.vue?vue&type=script&lang=js&"
export * from "./Edelstahl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports